import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import {
    getUserSettingsAction,
    saveSettingPreferences
} from './actions';
import Settings from '../../components/privacy-settings/index';

class PrivacySettings extends Component {
    static propTypes = {
        getUserSettingsAction: PropTypes.func,
        saveSettingPreferences: PropTypes.func
    }

    componentDidMount() {
        this.props.getUserSettingsAction();
    }

    savePreferences = (request) => {
        this.props.saveSettingPreferences(request);
    }

    render() {
        return (
            <div>
                <Settings
                    handleOnSave={this.savePreferences}
                    {...this.props} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        settingPreferences: state.privacySettings.settingPreferences,
        isSaveInProgress: state.privacySettings.isSaveInProgress,
        isDataLoaded: state.privacySettings.isDataLoaded
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getUserSettingsAction,
        saveSettingPreferences
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(PrivacySettings));



// WEBPACK FOOTER //
// ./app/containers/privacy-settings/index.js